<template>
  <el-row class="nav">
    <PersonalInfo
      ref="PersonalInfo"
      @submitDialog="$store.dispatch('updateSession')"
    />

    <div class="userInfo" @click="goUserInfo">
      <div class="headImgContainer">
        <el-image
          class="headImg"
          fit="cover"
          :src="$store.state.session.user.avatar"
        ></el-image>
      </div>

      <div class="display_name">
        {{ $store.state.session.user.display_name }}
      </div>
      <div style="margin-top: 14px">
        {{ $store.state.session.user.mobile }}
      </div>
    </div>

    <el-col>
      <el-menu
        :default-active="defaultActive"
        :unique-opened="true"
        :router="true"
        background-color="#fff"
        active-text-color="#EE8159"
      >
        <template v-for="item in navConfig">
          <template v-if="!item.children">
            <el-menu-item :index="item.route" :key="item.name">
              <i :class="item.icon"></i>
              <span slot="title" v-text="item.name"></span>
            </el-menu-item>
          </template>
          <template v-if="item.children">
            <el-submenu :index="item.route" :key="item.name">
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <template v-for="item2 in item.children">
                  <el-menu-item :index="item2.route" :key="item2.name">
                    <i :class="item2.icon"></i>
                    <span slot="title" v-text="item2.name"></span>
                  </el-menu-item>
                </template>
              </el-menu-item-group>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import initNavConfig from "@/assets/js/nav";
import PersonalInfo from "@/views/account/PersonalInfo.vue";

export default {
  name: "MainNav",
  components: {
    PersonalInfo,
  },
  data() {
    return {
      navConfig: null,
      defaultActive: "",
    };
  },
  watch: {
    "$route.path": function (value) {
      this.defaultActive = value;
    },
    "$store.state.session.permission_list": function (value) {
      this.init();
    },
  },

  created() {
    this.init();
  },
  mounted() {
    this.defaultActive = this.$route.path;
  },
  methods: {
    init() {
      var cloneNavConfig = this._.cloneDeep(initNavConfig); //FIXME 防止下面.map中改变原始initNavConfig
      this.navConfig = cloneNavConfig[this.$route.matched[0].name]
        .filter((item) => this.$store.getters.checkPermission(item.permission))
        .map((item) => {
          if (item.children)
            item.children = item.children.filter((child) =>
              this.$store.getters.checkPermission(child.permission)
            );
          return item;
        });
    },
    goUserInfo() {
      this.$refs.PersonalInfo.Type = "Edit";
      this.$refs.PersonalInfo.Show();
    },
  },
};
</script>

<style scoped lang="scss">
.nav {
  // height: calc(100vh - #{$headerHeight});
  background: #fff;
  // height: 100%;
  display: flex;
  flex-direction: column;
  .userInfo {
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #4e4e4e;
    width: 100%;
    height: 200px;
    border-bottom: 1px solid #f4f4f4;
    margin-bottom: 12px;
    cursor: pointer;
    .headImgContainer {
      width: 62px;
      height: 62px;
      position: relative;
      .headImg {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .display_name {
      margin-top: 16px;
      font-size: 16px;
      // width: $navWidth * 0.75;
      // white-space: nowrap;
      overflow: hidden;
      // text-overflow: ellipsis;
    }
  }
  .el-menu {
    overflow: auto;
    width: $navWidth;
    border: none;
    /deep/.el-menu-item,
    /deep/.el-submenu__title {
      // height: 40px;
      // line-height: 40px;
      // text-align: center;
      box-sizing: border-box;
      background: #fff !important;
      border-left: 3px solid transparent !important;
      &.is-active {
        background: $warningPlainColor !important;
        border-left: 3px solid $warningColor !important;
      }
      i:first-child {
        margin-left: 20px;
      }
    }
  }
}

// 防止二级菜单出现横向滚动条
/deep/.el-submenu .el-menu-item {
  min-width: 0;
  padding-right: 0;
}
</style>
